
export default [
    // 制成基础管理
    {
        path: "/process-base",
        name: "ProcessBaseManagement",
        component: () =>
            import("@/components/page/productManagement/ProcessBaseManagement"),
        meta: { title: "nav.procProcessManage" },
    },
    // 制成指标管理
    {
        path: "/process-indicator",
        name: "ProcessIndicatorManagement",
        component: () =>
            import("@/components/page/productManagement/ProcessIndicatorManagement.vue"),
        meta: { title: "nav.procFactorManage" },
    },
    // 制造过程记录（小批次）
    {
        path: "/process-monitoring/record",
        name: "processMonitoringRecord",
        component: () =>
            import("@/components/page/processMonitoring/processMonitoringRecord.vue"),
        meta: { title: "nav.procLotRecord" },
    },
    {
        path: "/process-monitoring/record/detail",
        name: "processMonitoringRecordDetail",
        component: () =>
            import("@/components/page/processMonitoring/processMonitoringRecordDetail.vue"),
        meta: { title: "nav.procLotRecordDetail" },
    },
    // 制造过程记录（大批次）
    {
        path: "/process-monitoring/large-batch-record",
        name: "processMonitoringLargeBatchRecord",
        component: () =>
            import("@/components/page/processMonitoring/processMonitoringLargeBatchRecord.vue"),
        meta: { title: "nav.procBatchRecord" },
    },
    {
        path: "/process-monitoring/large-batch-record/detail",
        name: "processMonitoringLargeBatchRecordDetail",
        component: () =>
            import("@/components/page/processMonitoring/processMonitoringLargeBatchRecordDetail.vue"),
        meta: { title: "nav.procBatchRecordDetail" },
    },
    // 制造过程模板
    {
        path: "/process-monitoring/template",
        name: "processMonitoringTemplate",
        component: () =>
            import("@/components/page/processMonitoring/template/processMonitoringTemplate.vue"),
        meta: { title: "nav.procTpl" },
    },
    // 制造过程模板详情
    {
        path: "/process-monitoring/template/detail",
        name: "processMonitoringTemplateDetail",
        component: () =>
            import("@/components/page/processMonitoring/template/templateDetail.vue"),
        meta: { title: "nav.procTplDetail" },
    },
    // 制成数据分布图
    {
        path: "/process-monitoring/data-dist-chart",
        name: "processMonitoringDataDistributionChart",
        component: () =>
            import("@/components/page/processMonitoring/distributionChart.vue"),
        meta: { title: "nav.procDataDistChart" },
    }
];
